import * as React from 'react'
import { inject, observer } from 'mobx-react'
import posed, { PoseGroup } from 'react-pose'

import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'
import {
  getCategoriesByBrand,
  getLocalizedCategoryData,
} from 'src/utils/category'
import Brand from 'src/templates/brand'
import Ui from 'src/stores/ui'

import styles from './Menu.module.scss'
import LanguageContext from '../LanguageContext'

const Background = posed.div({
  enter: { opacity: 0.6 },
  exit: { opacity: 0 },
})

type Props = {
  ui?: Ui
  menu: any
  brand?: Brand
  activeBrand?: boolean
}

@inject('brand', 'ui')
@observer
class Menu extends React.Component<Props> {
  contentRef: React.RefObject<HTMLDivElement>
  wrapperRef: React.RefObject<HTMLDivElement>

  constructor(props: Props) {
    super(props)
    this.wrapperRef = React.createRef()
    this.contentRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event: any) => {
    if (
      this.wrapperRef &&
      this.wrapperRef.current &&
      this.wrapperRef.current.contains(event.target) &&
      this.contentRef &&
      this.contentRef.current &&
      !this.contentRef.current.contains(event.target)
    ) {
      this.closeMenu()
    }
  }

  closeMenu = () => {
    const { ui } = this.props
    ui.setActiveMenu('')
  }

  render() {
    const { ui, menu, brand, activeBrand } = this.props
    const active = ui.activeMenu === 'menu'

    const menuClass = active
      ? [styles.menuOverlay, styles.menuOverlayActive].join(' ')
      : styles.menuOverlay

    if (!menu) {
      return null
    }
    let categories = null
    if (brand && brand.activeBrand) {
      categories = getCategoriesByBrand(brand.activeBrand.centraId)
    }

    return (
      <React.Fragment>
        <PoseGroup>
          {active && (
            <Background
              key="background"
              id="background"
              className={styles.background}
            />
          )}
        </PoseGroup>
        <LanguageContext.Consumer>
          {context => (
            <div ref={this.wrapperRef} className={menuClass} style={activeBrand ? {} : { height: 'calc(100vh - 80px)'}}>
              <div className={styles.menuBackground}>
                <nav ref={this.contentRef} className={styles.menuContent}>
                  {categories &&
                    categories.map((cat: any, index: number) => (
                      <div key={index} className={styles.category}>
                        <LinkComponent
                          onClick={this.closeMenu}
                          className={styles.stepOne}
                          to={`${brand.activeBrand.slug}/${cat.completeUri}`}
                        >
                          {getLocalizedCategoryData(cat, context.locale).name}
                        </LinkComponent>
                        <div className={styles.subCategories}>
                          {cat.categories &&
                            Object.keys(cat.categories).map(
                              (subcat: any, index: number) =>
                                cat.categories[subcat].brands.includes(
                                  brand.activeBrand.centraId
                                ) && (
                                  <div
                                    key={'sub' + index}
                                    className={styles.subColumn}
                                  >
                                    <LinkComponent
                                      onClick={this.closeMenu}
                                      className={styles.stepTwo}
                                      to={`${brand.activeBrand.slug}/${cat.categories[subcat].completeUri}`}
                                    >
                                      {
                                        getLocalizedCategoryData(
                                          cat.categories[subcat],
                                          context.locale
                                        ).name
                                      }
                                    </LinkComponent>
                                    {cat.categories[subcat].categories &&
                                      Object.keys(
                                        cat.categories[subcat].categories
                                      ).map(
                                        (lowcat: any, index: number) =>
                                          cat.categories[subcat].categories[
                                            lowcat
                                          ].brands.includes(
                                            brand.activeBrand.centraId
                                          ) && (
                                            <LinkComponent
                                              onClick={this.closeMenu}
                                              key={`lowcat-${index}`}
                                              className={styles.stepThree}
                                              to={`${brand.activeBrand.slug}/${cat.categories[subcat].categories[lowcat].completeUri}`}
                                            >
                                              {
                                                getLocalizedCategoryData(
                                                  cat.categories[subcat]
                                                    .categories[lowcat],
                                                  context.locale
                                                ).name
                                              }
                                            </LinkComponent>
                                          )
                                      )}
                                  </div>
                                )
                            )}
                        </div>
                      </div>
                    ))}
                  {menu && menu.links && menu.links.length > 0 && (
                    <div className={styles.mainNav}>
                      {menu.links.map((link: any, index: number) => (
                        <LinkComponent
                          onClick={this.closeMenu}
                          className={styles.stepOne}
                          to={link.fields.slug}
                          key={index}
                        >
                          {link.fields.title}
                        </LinkComponent>
                      ))}
                    </div>
                  )}
                </nav>
              </div>
            </div>
          )}
        </LanguageContext.Consumer>
      </React.Fragment>
    )
  }
}

export default Menu
